import HTTP from './axios';

// const axios = require('axios').default;

const CalendarService = {
  get: id => HTTP.get(`/calendars/${id}`).then(response => response.data.data),
  getBySchedule: id => HTTP.get(`/calendars/schedules/${id}`).then(response => response.data.data),
  getDates: (id, date, type) => HTTP.post(`/calendars/${id}/dates`, { date, type }).then(response => response.data.data),
  getTimes: (id, date, type) => HTTP.post(`/calendars/${id}/times`, { date, type }).then(response => response.data.data),
  search: query => HTTP.post('/calendars/search', query).then(response => response.data.data),
  schedule: (calendarId, scheduleId, patientId, cpf, covenantId, specialityId, particular, coupon, serviceChannelId, serviceChannelUrl) => {
    let params = {
      scheduleId, patientId, cpf, covenantId, specialityId, particular, coupon, serviceChannelId, serviceChannelUrl
    };
    return HTTP.post(`/calendars/${calendarId}/schedule`, params).then(response => response.data.data);
  },

  confirmSchedulePayment: (calendarId, scheduleId, paymentId) => HTTP.put(`/calendars/${calendarId}/schedules/${scheduleId}/payments/${paymentId}`)
    .then(response => response.data.data),

  // paySchedule: (userId, amount, description, amountDetails, returnUrl, cancelUrl) =>
  // axios.post(`http://production.wdyms3zw2j.us-east-1.elasticbeanstalk.com/v1/users/${userId}/payments`,
  //   {
  //     amount_in_cents: amount,
  //     description,
  //     amount_details: amountDetails,
  //     return_url: returnUrl,
  //     cancel_url: cancelUrl,
  //   },
  //   {
  //     headers: {
  //       Authorization: `Basic ${process.env.VUE_APP_PAYMENT_API_TOKEN}`,
  //       'Content-Type': 'application/json',
  //       Accept: 'application/json',
  //     },
  //   }).then(response => response.data),

  getCovenants: id => HTTP.get(`/calendars/${id}/covenants`).then(response => response.data.data),
};

export default CalendarService;
